import styled from 'styled-components';

import { colors, responsive } from '@/utils';

export const StyledCameraStreamHealthTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${responsive.spacing.xsmall};
`;

/* Caution colour on the glyph only; the text stays default so it reads as a note. */
export const StyledStaleNote = styled.div`
  display: flex;
  align-items: center;
  gap: ${responsive.spacing.xsmall};

  svg {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    color: ${colors.icon.caution[100]};
  }
`;
